import { Collapse } from 'antd';
import './questions.scss';
import TextHelper from '../../helpers/text.helper.js';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
const { Panel } = Collapse

const Questions = ({ items }) => {

  if (!items) return null
  return (
    <div className="questions">
      <Collapse 
        bordered={false}
        expandIcon={({ isActive }) => (isActive ? <MinusOutlined /> : <PlusOutlined />)}                        
        className="faq-collapse"
      >
        {items.map(({ question, answer }, index) => (
          <Panel
            key={`question-${index}`}
            header={question}
            className="question-panel"
          >
            <div className="answer">
              {answer.map((block, index) => (
                <div key={`answer-${index}`} className={`answer-${block.type}`}>
                  {TextHelper.renderBlock(block)}
                </div>
              ))}
            </div>
          </Panel>
        ))}
      </Collapse>
    </div>
  )
}

export default Questions;